import { useTranslation } from 'react-i18next';
import { useShowNotification } from 'shared/hooks/notification/use-show-notification';
import { usePostAttachment } from '../../entities/document/api/hooks';

export type UseAttachmentActionsProps = {
  documentId: number;
  attachmentId: number;
};

export const useAttachmentActions = (props: UseAttachmentActionsProps) => {
  const { t } = useTranslation(['documents']);
  const showNotification = useShowNotification();

  const { mutateAsync: _save } = usePostAttachment();

  /**
   * Zapisuje dane do załącznika
   */
  const save = async (data: { type: string; data: any }) => {
    try {
      await _save({
        ...data,
        documentId: props.documentId,
        attachmentId: props.attachmentId,
      });
      showNotification({
        message: t('attachmentSaved'),
        variant: 'success',
      });
    } catch (error) {
      showNotification({
        message: t('attachmentSaveError'),
        variant: 'error',
      });
      throw error;
    }
  };

  return { save };
};
